<template>
  <div>
    <div class="coupon-list-window" :class="coupon.coupon === true ? 'on' : ''">
      <div class="title">
        优惠券<span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div class="coupon-list" v-if="coupon.list.length > 0">
        <div
          class="item acea-row row-center-wrapper"
          v-for="(item, index) in coupon.list"
          :key="index"
          @click="getCouponUser(index, item.id)"
        >
          <div class="money">
            ￥<span class="num">{{ item.usedAmount }}</span>
          </div>
          <div class="text">
            <div class="condition line1">购物满{{ item.withAmount }}元可用</div>
            <div class="data acea-row row-between-wrapper">
              <div>
                {{ item.startTime ? item.startTime + "-" : ""
                }}{{ item.endTime }}
              </div>
              <div
                class="bnt acea-row row-center-wrapper"
                :class="!item.isTake ? 'bg-color-red' : 'gray'"
              >
                {{ !item.isTake ? "立即领取" : "已领取" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--无优惠券-->
      <div class="pictrue" v-else>
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="coupon.coupon === false"
      @click="close"
    ></div>
  </div>
</template>
<script>
import { getCouponReceive } from "@api/user";
export default {
  name: "CouponPop",
  props: {
    coupon: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {
    close: function () {
      this.$emit("changeFun", { action: "changecoupon", value: false }); //$emit():注册事件；
    },
    getCouponUser: function (index, id) {
      let that = this,
        list = that.coupon.list;
      if (list[index].isTake === true) return;
      getCouponReceive(id)
        .then(function () {
          that.$dialog.toast({ mes: "已领取" });
          that.$set(list[index], "isTake", true);
          that.$emit("changefun", { action: "currentcoupon", value: index });
          that.$emit("changeFun", { action: "changecoupon", value: false });
        })
        .catch((error) => {
          if (error && error.response) {
            that.$dialog.toast({ mes: error.response.data.message });
          }
        });
    },
  },
};
</script>
